import React from 'react';
import DataPlataformListPage from '../../Components/DataPlataformListPage';

const icons = {
    exercicio: <img src="/images/icons/calendar_search_black.svg" alt="Exercício" width={18} style={{ marginRight: 6 }} />,
    uf: <img src="/images/icons/point_on_map_black.svg" alt="UF" width={18} style={{ marginRight: 6 }} />,
    municipio: <img src="/images/icons/city_black.svg" alt="Município" width={18} style={{ marginRight: 6 }} />,
    nome: <img src="/images/icons/filter_black.svg" alt="Beneficiário" width={18} style={{ marginRight: 6 }} />,
    cnpj: <img src="/images/icons/magnifer_black.svg" alt="CNPJ" width={18} style={{ marginRight: 6 }} />,
    tributo: <img src="/images/icons/filter_black.svg" alt="Tributo" width={18} style={{ marginRight: 6 }} />,
    programa: <img src="/images/icons/magnifer_black.svg" alt="Programa" width={18} style={{ marginRight: 6 }} />,
    valor: <img src="/images/icons/dollar_minimalistic_black.svg" alt="Valor" width={18} style={{ marginRight: 6 }} />,
};

const columns = [
    { key: 'exercicio', label: 'Exercício', icon: icons.exercicio },
    { key: 'uf', label: 'UF', icon: icons.uf, align: 'center' },
    { key: 'nome_municipio', label: 'Município', icon: icons.municipio },
    { key: 'nome', label: 'Beneficiário', icon: icons.nome },
    { key: 'cnpj', label: 'CNPJ', icon: icons.cnpj },
    { key: 'tributo', label: 'Tributo', icon: icons.tributo },
    { key: 'programa_isencao', label: 'Programa de isenção', icon: icons.programa },
    { key: 'sum_valor', label: 'Valor', icon: icons.valor, align: 'right', format: v => Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) },
];

const Dirbi = () => (
    <DataPlataformListPage
        datasetKey="dirbi"
        title="DIRBI"
        iconLeft={<img src="/images/icons/city.svg" width="18" alt="União" />}
        label="UNIÃO"
        api={{
            search: `${process.env.REACT_APP_API_URL}/dirbi`,
            grafico: `${process.env.REACT_APP_API_URL}/dirbi-grafico`,
            exercicios: `${process.env.REACT_APP_API_URL}/dirbi-exercicios`,
            contas: `${process.env.REACT_APP_API_URL}/dirbi-tributos`,
            ufs: `${process.env.REACT_APP_API_URL}/filtro-localidade`,
            email: `${process.env.REACT_APP_API_URL}/dirbi-email`,
        }}
        columns={columns}
        contaQueryParam="tributo"
        contasMode="flat"
        contaPlaceholder="Selecione tributo(s)"
    />
);

export default Dirbi;
